// @flow weak

import { IBreakpoints } from './breakpoints';

export default function createMixins(breakpoints: IBreakpoints) {
  function gutters(_styles: any) {
    const styles = _styles;
    styles.paddingLeft = 16;
    styles.paddingRight = 16;
    styles[breakpoints.up('sm')] = {
      paddingLeft: 24,
      paddingRight: 24,
    };
    return styles;
  }

  return { gutters };
}
